import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import MyWishlist from '../Profile/MyWishlist'

const MyWishListPage = () => {
  return (
    <>
        <Header/>
        <MyWishlist/>
        <Footer/>
    </>
  )
}

export default MyWishListPage
